import styled from '@emotion/styled';

const FieldQuestion = styled('div')`
  display: flex;
  align-items: center;
`;

export default FieldQuestion;
